const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImageBlack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Raggruppa 4702"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Tracciato 2538",
    d: "M5.325 13.375a5.926 5.926 0 0 1 3.5.525 3.327 3.327 0 0 0 2.188.35 2.628 2.628 0 0 0 .963-.525c.35-.35.7-.7 1.138-1.225a7.885 7.885 0 0 1 4.025-2.625 8.4 8.4 0 0 1 2.361-.262 20.365 20.365 0 0 0-.35-3.763 3.964 3.964 0 0 0-1.137-2.362A4.539 4.539 0 0 0 15.65 2.35a24.455 24.455 0 0 0-4.9-.35 24.455 24.455 0 0 0-4.9.35 4.539 4.539 0 0 0-2.363 1.137A4.539 4.539 0 0 0 2.35 5.85a24.455 24.455 0 0 0-.35 4.9 26.218 26.218 0 0 0 .263 4.113 7.71 7.71 0 0 1 3.062-1.488z",
    transform: "translate(-.25 -.25)",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Tracciato 2539",
    d: "M17.575 12.968a5.927 5.927 0 0 0-3.15 2.1A8.711 8.711 0 0 1 13.2 16.38a3.69 3.69 0 0 1-1.838.962 4.891 4.891 0 0 1-3.15-.525 4.027 4.027 0 0 0-2.537-.35 5.821 5.821 0 0 0-2.8 1.488l-.175.175a3.557 3.557 0 0 0 2.1 2.1 20.046 20.046 0 0 0 6.037.612c4.2 0 6.125-.525 7.175-1.4.962-.875 1.488-2.538 1.575-6.475v-.175a4.359 4.359 0 0 0-2.012.176z",
    transform: "translate(-.337 -1.593)",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Tracciato 2540",
    d: "M1.7 20.1z",
    transform: "translate(-.213 -2.513)",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Tracciato 2541",
    d: "M21 11.375V10.5C21 1.838 19.163 0 10.5 0S0 1.837 0 10.5a18.825 18.825 0 0 0 .787 6.563C2.013 20.212 4.725 21 10.5 21c8.313 0 10.325-1.75 10.5-9.625zM2.1 5.6a4.539 4.539 0 0 1 1.137-2.363A4.539 4.539 0 0 1 5.6 2.1a24.455 24.455 0 0 1 4.9-.35 24.455 24.455 0 0 1 4.9.35 3.964 3.964 0 0 1 2.363 1.137A4.539 4.539 0 0 1 18.9 5.6a20.365 20.365 0 0 1 .35 3.763 6.06 6.06 0 0 0-2.363.262 7.885 7.885 0 0 0-4.025 2.625c-.437.525-.788.875-1.138 1.225a2.628 2.628 0 0 1-.962.525 3.98 3.98 0 0 1-2.187-.35 5.926 5.926 0 0 0-3.5-.525 6.6 6.6 0 0 0-3.15 1.488A49.408 49.408 0 0 1 1.75 10.5a24.455 24.455 0 0 1 .35-4.9zm-.612 11.987zm16.188.263c-1.05.875-2.975 1.4-7.175 1.4-2.888 0-4.725-.175-5.95-.7a3.557 3.557 0 0 1-2.1-2.1l.175-.175a5.13 5.13 0 0 1 2.8-1.488 4.733 4.733 0 0 1 2.538.35 5.008 5.008 0 0 0 3.15.525 4.108 4.108 0 0 0 1.836-.962c.438-.437.875-.962 1.225-1.312a5.927 5.927 0 0 1 3.15-2.1 4.359 4.359 0 0 1 2.012-.175v.175c-.174 4.025-.7 5.687-1.662 6.562z",
    style: {
      fill: "#000"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Raggruppa 4703",
    transform: "translate(4.375 4.375)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    "data-name": "Ellisse 64",
    cx: 2,
    cy: 1.5,
    rx: 2,
    ry: 1.5,
    transform: "translate(1.625 1.771)",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Tracciato 2542",
    d: "M8.5 5A3.5 3.5 0 1 0 12 8.5 3.51 3.51 0 0 0 8.5 5zm0 5.25a1.75 1.75 0 1 1 1.75-1.75 1.755 1.755 0 0 1-1.75 1.75z",
    transform: "translate(-5 -5)",
    style: {
      fill: "#000"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageBlack);
export default __webpack_public_path__ + "static/media/ImageBlack.3ec99bd9db36405ecb7d4c2aacb11cc9.svg";
export { ForwardRef as ReactComponent };